export const mouseEnter = 300; // Changed from 100ms to 300ms for debounced popover hover
export const mouseLeave = 150;
